import React, { useEffect, useState, useCallback } from "react";
import { Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";

import { getLegajoById } from "../../../api/marcacionApi";
import {
  getEgresos,
  getIngresos,
  getSignosVitalesbyLegajo,
  getTareaByPacienteandDate,
} from "../../../api/pacienteApi";
import {
  getEvolucionesbylegajo,
  getMedicacionesbyLegajo,
  getInsumoUsadobyLegajo,
} from "../../../api/EvolucionApi";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

// ---------- Ajuste de íconos Leaflet ----------
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

// ---------- Componentes auxiliares ----------
function Tareas({ title, tareas }) {
  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <h2 className="card-title h5">{title}</h2>
        <ul className="list-group list-group-flush">
          {tareas.map((work, index) => (
            <li className="list-group-item" key={index}>
              <div>{work.tarea}</div>
              <small className={work.estado === "SI" ? "text-success" : "text-danger"}>
                {work.estado === "SI" ? "Completo" : "Incompleto"}
              </small>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function Evoluciones({ title, evoluciones }) {
  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <h2 className="card-title h5">{title}</h2>
        <ul className="list-group list-group-flush">
          {evoluciones.map((work, index) => (
            <li className="list-group-item" key={index}>
              <div>{work.texto}</div>
              <small className="text-muted">{work.fechahora}</small>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function Medicacion({ title, meds }) {
  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <h2 className="card-title h5">{title}</h2>
        <ul className="list-group list-group-flush">
          {meds.map((work, index) => (
            <li className="list-group-item" key={index}>
              <div><strong>Medicamento:</strong> {work.medicacion}</div>
              <div><strong>Dosis:</strong> {work.dosis}</div>
              <small className="text-muted">{work.fechahora}</small>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function Insumos({ title, ins }) {
  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <h2 className="card-title h5">{title}</h2>
        <ul className="list-group list-group-flush">
          {ins.map((work, index) => (
            <li className="list-group-item" key={index}>
              <div><strong>Insumo:</strong> {work.insumo}</div>
              <div><strong>Cantidad:</strong> {work.cantidad}</div>
              <small className="text-muted">{work.fechahora}</small>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function SignosVitales({ title, signosvitales }) {
  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <h2 className="card-title h5">{title}</h2>
        <ul className="list-group list-group-flush">
          {signosvitales.map((work, index) => (
            <li className="list-group-item" key={index}>
              <div><strong>Temp.:</strong> {work.temperatura} ˚C - <strong>SaTO2:</strong> {work.sato2}</div>
              <div><strong>PA:</strong> {work.pa} mm Hg - <strong>FC:</strong> {work.fc} LPM</div>
              <div><strong>FR:</strong> {work.fr} RPM - <strong>HGT:</strong> {work.hgt} mmdl</div>
              <small className="text-muted">{work.fechacreacion}</small>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function EgresosEIngresos({ title, egresos, ingresos }) {
  return (
    <div className="card shadow-sm">
      <div className="card-body">
        <h2 className="card-title h5">{title}</h2>
        <h3>Ingresos</h3>
        <ul className="list-group list-group-flush">
          {ingresos.map((work, index) => (
            <li className="list-group-item" key={index}>
              <div>{work.liq} - {work.cant} ml</div>
              <small className="text-muted">{work.fechahora}</small>
            </li>
          ))}
        </ul>
        <h3>Egresos</h3>
        <ul className="list-group list-group-flush">
          {egresos.map((work, index) => (
            <li className="list-group-item" key={index}>
              <div>{work.liq} - {work.cant} ml</div>
              <small className="text-muted">{work.fechahora}</small>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

function LoadingCard() {
  return (
    <div className="card shadow-sm mb-4">
      <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: "120px" }}>
        <Spinner animation="border" role="status" />
      </div>
    </div>
  );
}

// ---------- FUNCIÓN UTIL para validar coordenadas ----------
const isValidCoord = (v) =>
  v !== null &&
  v !== undefined &&
  v !== "" &&
  !Number.isNaN(Number(v)) &&
  Number(v) !== 0; // evita 0,0 cuando el string está vacío

// ---------- COMPONENTE PRINCIPAL ----------
function App() {
  const { id } = useParams();

  // --- State ---
  const [Legajo, setLegajo] = useState([]);
  const [egresos, setEgresos] = useState([]);
  const [ingresos, setIngresos] = useState([]);
  const [meds, setMedicaciones] = useState([]);
  const [ins, setInsumos] = useState([]);
  const [evoluciones, setEvoluciones] = useState([]);
  const [tareas, setTareas] = useState([]);
  const [signosvitales, setSignosVitales] = useState([]);
  const [ESTADO, setESTADO] = useState("En Progreso");

  const [loading, setLoading] = useState(true);
  const [loadingTareas, setLoadingTareas] = useState(true);
  const [loadingEvol, setLoadingEvol] = useState(true);
  const [loadingSignos, setLoadingSignos] = useState(true);
  const [loadingEgresos, setLoadingEgresos] = useState(true);
  const [loadingInsumos, setLoadingInsumos] = useState(true);
  const [loadingMeds, setLoadingMeds] = useState(true);

  // --- Datos iniciales ---
  const assigmentValue = useCallback(async () => {
    try {
      const legajo = await getLegajoById(id);
      if (legajo[0].estaConfirmado.data[0] === 1) setESTADO("Finalizado");
      setLegajo(legajo[0]);

      getTareaByPacienteandDate({ idpaciente: legajo[0].IdPaciente, fecha: legajo[0].Fecha })
        .then(setTareas)
        .finally(() => setLoadingTareas(false));

      getEvolucionesbylegajo(id)
        .then(setEvoluciones)
        .finally(() => setLoadingEvol(false));

      getSignosVitalesbyLegajo(id)
        .then(setSignosVitales)
        .finally(() => setLoadingSignos(false));

      getEgresos(id)
        .then(setEgresos)
        .finally(() => setLoadingEgresos(false));

      getIngresos(id).then(setIngresos);

      getInsumoUsadobyLegajo(id)
        .then(setInsumos)
        .finally(() => setLoadingInsumos(false));

      getMedicacionesbyLegajo(id)
        .then(setMedicaciones)
        .finally(() => setLoadingMeds(false));

      setLoading(false);
    } catch (err) {
      console.log(err);
    }
  }, [id]);

  useEffect(() => {
    assigmentValue();
  }, [assigmentValue]);

  // --- Validación de coordenadas ---
  const hasEntradaCoords =
    isValidCoord(Legajo.Latitud) && isValidCoord(Legajo.Longitud);
  const hasSalidaCoords =
    isValidCoord(Legajo.latsalida) && isValidCoord(Legajo.longsalida);

  const coordenadasMapa1 = hasEntradaCoords
    ? { lat: Number(Legajo.Latitud), lng: Number(Legajo.Longitud) }
    : null;

  const coordenadasMapa2 = hasSalidaCoords
    ? { lat: Number(Legajo.latsalida), lng: Number(Legajo.longsalida) }
    : null;

  // --- Carga global ---
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  // --- Render ---
  return (
    <div className="container py-4">
      {/* ---------- Cabecera Legajo ---------- */}
      <div className="card mb-4 shadow-sm">
        <div className="card-body">
          <h1 className="card-title">Legajo</h1>
          <p><strong>Cuenta:</strong> {Legajo.Usuario}</p>
          <p><strong>Usuario del servicio:</strong> {Legajo.Paciente}</p>
          <p><strong>Estado:</strong> {ESTADO}</p>
          <p><strong>Guardia Hs.:</strong> {Legajo.TotalHoraMaximo}</p>
          <p><strong>Hora Extra Máximo:</strong> {Legajo.horaextramaximo}</p>
          <p><strong>Entrada Original:</strong> {Legajo.entradaoriginal}</p>
          <p><strong>Salida Original:</strong> {Legajo.salidaoriginal}</p>
          <p><strong>Fecha de guardia:</strong> {Legajo.Fecha} / {Legajo.HoraEntrada} al {Legajo.FechaSalida} / {Legajo.HoraSalida}</p>
        </div>
      </div>

      {/* ---------- Tareas ---------- */}
      {loadingTareas ? <LoadingCard /> : <Tareas title="Tareas" tareas={tareas} />}

      {/* ---------- Mapa Entrada ---------- */}
      {hasEntradaCoords && (
        <div className="mb-4">
          <h3>Mapa 1: Entrada</h3>
          <MapContainer
            center={coordenadasMapa1}
            zoom={13}
            style={{ height: "300px", width: "100%" }}
          >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={coordenadasMapa1}>
              <Popup>Ubicación de entrada</Popup>
            </Marker>
          </MapContainer>
        </div>
      )}

      {/* ---------- Mapa Salida o Mensaje ---------- */}
      <div className="mb-4">
        <h3>Mapa 2: Salida</h3>
        {hasSalidaCoords ? (
          <MapContainer
            center={coordenadasMapa2}
            zoom={13}
            style={{ height: "300px", width: "100%" }}
          >
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={coordenadasMapa2}>
              <Popup>Ubicación de salida</Popup>
            </Marker>
          </MapContainer>
        ) : (
          <div className="card shadow-sm">
            <div className="card-body">
              <p className="text-muted mb-0">
                Marcar salida para visualizar el mapa.
              </p>
            </div>
          </div>
        )}
      </div>

      {/* ---------- Evoluciones ---------- */}
      {loadingEvol ? <LoadingCard /> : <Evoluciones title="Evoluciones" evoluciones={evoluciones} />}

      {/* ---------- Columnas de tarjetas ---------- */}
      <div className="row">
        <div className="col-md-4">
          {loadingSignos ? <LoadingCard /> : <SignosVitales title="Signos Vitales" signosvitales={signosvitales} />}
        </div>
        <div className="col-md-4">
          {loadingEgresos ? <LoadingCard /> : <EgresosEIngresos title="Egresos e Ingresos" egresos={egresos} ingresos={ingresos} />}
        </div>
        <div className="col-md-4">
          {loadingMeds ? <LoadingCard /> : <Medicacion title="Medicaciónes" meds={meds} />}
        </div>
        <div className="col-md-4">
          {loadingInsumos ? <LoadingCard /> : <Insumos title="Insumos" ins={ins} />}
        </div>
      </div>
    </div>
  );
}

export default App;
